<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>
        <i class="fa-solid fa-building me-2"></i>
        <ng-container *ngIf="viewMode === ViewMode.INSERT">Abteilung anlegen</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.EDIT">Abteilung bearbeiten</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.VIEW">Abteilung</ng-container>
    </h3>
</div>

<form [formGroup]="form">
    <div class="row">
        <div class="col">
            <label>Name</label>
            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode !== ViewMode.VIEW">
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.name }}</p>

            <label>Leitung</label>
            <input class="form-control" typeaheadOptionField="displayName"
                   formControlName="_userSearch"
                   *ngIf="viewMode !== ViewMode.VIEW"
                   [typeahead]="users$"
                   [typeaheadAsync]="true"
                   [typeaheadMinLength]="4"
                   [typeaheadWaitMs]="1000"
                   (typeaheadOnSelect)="onSelectUser($event)"
                   (typeaheadNoResults)="typeaheadUsersNoResults($event)"
                   (typeaheadLoading)="typeaheadUsersLoading($event)"
                   autocomplete="off"
                   placeholder="Bitte Benutzer suchen">

            <span *ngIf="loading"><i class="fa fa-spinner fa-pulse fa-2x mt-2"></i></span>

            <p *ngIf="noUserResult" class="bg-warning px-2 py-1 mt-2">Keine Benutzer gefunden</p>
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.lead }}</p>
        </div>
    </div>
</form>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode === ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
